import { uploadLogs } from './bUlsUploader';
import { formatForUpload } from './bUlsFormatter';
import { TraceLevel } from './TraceLevel';
var bUlsCache = /** @class */ (function () {
    function bUlsCache(userSessionId, remoteUlsEndpoint) {
        var _this = this;
        /** Rolling counter used to identify set of logs being uploaded to the server. */
        this.uploadId = 0;
        /** Actually cache collection */
        this.logCache = [];
        /** Base timestamp for all the logs in current batch */
        this.timestampBase = Date.now();
        this.userSessionId = '00000000-0000-0000-0000-000000000000';
        this.flushOnClose = function () {
            _this.triggerUpload(false, false);
        };
        this.flush = function () {
            _this.triggerUploadAsync();
        };
        this.triggerUploadAsync = function () {
            window.setTimeout(function () { return _this.triggerUpload(true, true); }, 0);
        };
        this.triggerUpload = function (scheduleNextUpload, async) {
            window.clearTimeout(_this.timeoutId);
            if (_this.logCache.length > 0) {
                // increment upload Id
                _this.uploadId += 1;
                // and upload it after serializing into wire format
                var logsPayload = formatForUpload(_this.logCache, _this.userSessionId, _this.uploadId, _this.timestampBase);
                uploadLogs(logsPayload, _this.remoteUrlEndpoint, async);
                // reset cache
                _this.logCache = [];
                _this.timestampBase = Date.now();
            }
            // set the next execution if requested
            if (scheduleNextUpload) {
                _this.timeoutId = window.setTimeout(_this.triggerUploadAsync, bUlsCache.uploadCadenceInMsSec);
            }
        };
        this.userSessionId = userSessionId;
        this.remoteUrlEndpoint = remoteUlsEndpoint + '?usid=' + userSessionId;
        // kick off the Uls uploads with scheduleNextUplaod and async set to true
        window.setTimeout(function () { return _this.triggerUpload(true, true); }, 0);
    }
    bUlsCache.prototype.handleTrace = function (loggingArgs) {
        // trim the message if it's super long.
        if (loggingArgs.message.length > bUlsCache.messageMaxChars) {
            loggingArgs.message =
                loggingArgs.message.substr(0, bUlsCache.messageMaxChars - bUlsCache.trimmedMessage.length) +
                    bUlsCache.trimmedMessage;
        }
        // push to cache.
        this.logCache.push(loggingArgs);
        // upload if cache is full or the log is an Error-level statement.
        if (this.logCache.length > bUlsCache.uploadTriggerSize || loggingArgs.level === TraceLevel.Error) {
            this.triggerUploadAsync();
        }
    };
    bUlsCache.messageMaxChars = 3072; // 3KB
    bUlsCache.uploadCadenceInMsSec = 30 * 1000;
    bUlsCache.uploadTriggerSize = 30; // number of logs in cache which will trigger immediate upload.
    bUlsCache.trimmedMessage = '... [Trimmed]';
    return bUlsCache;
}());
export { bUlsCache };
//# sourceMappingURL=bUlsCache.js.map